import { queryString, request } from '../../../shared/api/httpClient';
import { addDays, startOfStoreDay } from '../../../shared/lib/format';
import type { Appointment } from '../model/appointment.types';

export async function listAppointments(from: string, to: string, timezone: string, signal?: AbortSignal) {
  const items: Appointment[] = [];
  let page = 1;
  while (true) {
    const result = await request<{ list: Appointment[]; pagination: { total: number } }>('/appointments' + queryString({
      from_time_ms: startOfStoreDay(from, timezone), to_time_ms: startOfStoreDay(addDays(to, 1), timezone) - 1, limit: 100, page,
    }), { signal });
    items.push(...result.list);
    if (items.length >= result.pagination.total || result.list.length === 0) break;
    page++;
  }
  return items;
}
